export const CCookieKeys = {
  originId: 'Origin-Id',
  apiKey: 'Current-Venue'
};
